import { type BoxProps, Flex, Text } from '@/ui';
import { Shape } from './Shape';

type Props = {
  label?: string;
  numRows?: number;
  shapeProps?: BoxProps;
};

const Bar = ({ ...props }: BoxProps) => (
  <Shape height="6px" w="100%" {...props} />
);

export const VerticalListIcon = ({
  label,
  numRows = 3,
  shapeProps = {},
}: Props & BoxProps) => {
  return (
    <Flex flexDir="column" gap="2px" w="70%">
      {label && (
        <Text
          color="gray.700"
          fontSize="10px"
          fontWeight="bold"
          mb="1px"
          textAlign="left"
        >
          {label}
        </Text>
      )}
      {Array.from({ length: numRows }).map((_, index) => (
        <Bar {...shapeProps} key={index} />
      ))}
    </Flex>
  );
};
